export const EVENT_NAME_COMPLEMENT = {
  'selecionar-plano': '_health_plan',
  'tipo-de-conta': '_account_type',
  cpf: '_check_cpf',
  'beneficio-corporativo': '_corporate_benefit',
  'dados-cadastrais': '_registration_data',
  'criar-senha': '_create_password',
  'identificador-do-plano-de-saude': '_clinic_identifier',
  'identificador-do-beneficio-corporativo': '_clinic_identifier',
  'identificador-clinica-whitelabel': '_clinic_identifier',
  'identificador-clinica-saas': '_clinic_identifier',
  'identificador-clinica-docpass': '_clinic_identifier',
  'identificador-clinica-rede-conexa': '_clinic_identifier',
  'forma-de-validacao': '_choose_validation',
  'validacao-sms': '_code_validation_sms',
  'validacao-email': '_code_validation_email',
}

export const ROUTES_WITHOUT_FOOTER_SPACING = ['tipo-de-conta']
